module.exports = __webpack_public_path__ + "img/greegmv5.7ce288da.png";